module.exports = __webpack_public_path__ + "media/marqeta_setup/hand_with_card-8225ba5a.png";